import React from "react";
import PropTypes from "prop-types";
import { change, Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/Lots/actions";
import {
  form,
  Form as AppForm,
  FormInput,
  Select
} from "MODULES/shared/components/Forms";

import { NAME, PAYMENT_TERMS, REFERENCE_NUMBER } from "APP_ROOT/constants";
import { Col } from "react-bootstrap";
import {
  COST_SPLIT,
  COST_SPLIT_LABEL,
  LOT_NAME,
  LOT_TYPE,
  LOT_TYPES,
  ORIGINAL_COST
} from "MODULES/Lots/constants";
import { toOptions } from "LIB/forms";
import { properCase } from "LIB/formatters/text";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { CONDITION, LEAD_TIME } from "MODULES/inventories/constants";
import NumberInput from "MODULES/shared/components/Forms/NumberInput/NumberInput";
import { SRP_CONDITION_OPTIONS } from "MODULES/Lots/Detail/LineItemsTable/Form";
import validate from "./validate";

const formName = "editLot";

export class Form extends React.Component {
  state = {
    contacts: []
  };

  render() {
    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <FormRow>
            <Col md={3}>
              <div className="form-group">
                <Field
                  name={LOT_TYPE}
                  component={Select}
                  options={toOptions(LOT_TYPES)}
                  label={properCase(LOT_TYPE)}
                  required
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <Field
                  name={NAME}
                  component={FormInput}
                  label={properCase(LOT_NAME)}
                  required
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <Field
                  name={REFERENCE_NUMBER}
                  component={FormInput}
                  label="Ref #"
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <Field
                  name={ORIGINAL_COST}
                  component={NumberInput}
                  label={properCase(ORIGINAL_COST)}
                  required
                />
              </div>
            </Col>
          </FormRow>
          <FormRow>
            <Col md={3}>
              <div className="form-group">
                <Field
                  label={COST_SPLIT_LABEL}
                  name={COST_SPLIT}
                  component={NumberInput}
                  roundDigits={0}
                  type="number"
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <Field
                  name={CONDITION}
                  component={Select}
                  options={SRP_CONDITION_OPTIONS}
                  label={properCase(CONDITION)}
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <Field
                  name={LEAD_TIME}
                  component={FormInput}
                  label="Lead Time (Days)"
                  type="number"
                  inputProps={{
                    min: 0
                  }}
                  required
                />
              </div>
            </Col>
          </FormRow>
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  setLot: PropTypes.func,
  lot: PropTypes.instanceOf(Object)
};

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.update(data)),
  setLot: val => dispatch(change(formName, PAYMENT_TERMS, val))
}))(
  form({
    form: formName,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/Edit/EditLot/Form.jsx